import styled, { css } from 'styled-components'

export const ChartContainer = styled.div<{ heightPx: number }>`
  width: 100%;
  height: ${({ heightPx }) => `${heightPx}px`};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
`

export const RightSection = styled.div(({ theme }) => css`
  text-align: right;
  font-size: ${theme.typography.tiny.pt_11_regular.fontSize};
  color: ${theme.palette.dark.raven};
  white-space: nowrap;
`)

export const StyledStrong = styled.strong(({ theme }) => css`
  display: block;
  font-weight: 700;
  font-size: ${theme.typography.tiny.pt_11_regular.fontSize};
  color: ${theme.palette.black};
`)
